import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';

@Injectable()
export class RoleHttpService {
  

  constructor(private http: HttpClient,
    private readonly urlBuilder: UrlBuilderService) { }

  getRoles(): Observable<string[]> {
    const url = this.urlBuilder.getUrl(`account/roles`);

    return this.http
      .get<string[]>(url).pipe(
      map(result => result || undefined)
      );
  }

}
